(function() { module.exports = this["wp"]["htmlEntities"]; }());